// One all page (buttons, and banner), not on compare page
import './tracking.js';
import '../../components/product-compare-button/index.js';
import ProductCompareBanner from '../../components/product-compare-banner/index.js';

document.querySelector('.Main')?.appendChild(new ProductCompareBanner().el);
